import { fetchRequestWithTypes } from './index.js';

export const PATCH_ONBOARDING_QUESTIONS_ANSWERS_REQUEST =
	'PATCH_ONBOARDING_QUESTIONS_ANSWERS_REQUEST';
export const PATCH_ONBOARDING_QUESTIONS_ANSWERS_SUCCESS =
	'PATCH_ONBOARDING_QUESTIONS_ANSWERS_SUCCESS';
export const PATCH_ONBOARDING_QUESTIONS_ANSWERS_ERRORED =
	'PATCH_ONBOARDING_QUESTIONS_ANSWERS_ERRORED';

export const patchOnboardingQuestions = (body) => {
	return fetchRequestWithTypes({
		types: [
			PATCH_ONBOARDING_QUESTIONS_ANSWERS_REQUEST,
			PATCH_ONBOARDING_QUESTIONS_ANSWERS_SUCCESS,
			PATCH_ONBOARDING_QUESTIONS_ANSWERS_ERRORED,
		],
		request: {
			method: 'PATCH',
			path: '/onboarding/api/v2/users/:uuid/questions/answers',
			body,
		},
	});
};
